<script setup lang="ts">
import { loadJsFile } from '@/utils'

async function initAds() {
  await loadJsFile(`https://stpd.cloud/assets/stpdwrapper.js`, [{ name: 'crossorigin', value: 'anonymous' }])
  const data = {};
  ((window?.stpdwrapper || []) as Array<typeof data>).push(data)
}

onMounted(() => {
  // nexttick when nav transition done
  setTimeout(initAds, 300)
})
</script>

<template>
  <ClientOnly>
    <template #placeholder>
      <div class="ads mis-10 min-w-300px w-300px lt-lg:hidden" />
    </template>
    <section class="ads mis-10 min-w-300px w-300px flex flex-col lt-lg:hidden">
      <div class="aspect-ratio-1 w-full flex-center rd-4 bg-gray-2">
        <ins class="stpdwrapper" :data-tag-id="7334" />
        <AdsBlockTips />
      </div>
      <div class="mt-6 aspect-ratio-1 h-600px w-full flex-center rd-4 bg-gray-2">
        <ins class="stpdwrapper" :data-tag-id="7335" />
        <AdsBlockTips />
      </div>
    </section>
  </ClientOnly>
</template>

<style lang="scss" scoped>
</style>
